import { PRODUCT_NAME } from '@/common/constants';
import { isSupportRequestOpen } from '@/common/relationships/src/utils';

import type { ForYouPageDetailsAnalyticsAttributes } from '../types';
import type { GetFastshiftSupportRequestsResponseData } from '@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';

export const isSupportedProduct = (productName?: string | null) => {
	const normalizedName = (productName ?? '').toUpperCase();
	return normalizedName === PRODUCT_NAME.JIRA || normalizedName === PRODUCT_NAME.CONFLUENCE;
};

export function buildDomainWideForYouPageDetailsAttributes(
	supportRequests: GetFastshiftSupportRequestsResponseData,
): ForYouPageDetailsAnalyticsAttributes {
	return {
		planTicketCount: supportRequests.length,
		planTicketList: supportRequests.map((request) => request.supportTicketId),
		hasRequestAssistancePathway: supportRequests.some((request) =>
			isSupportRequestOpen(request.status),
		),
		rowsMissingProductIcon: supportRequests.filter((request) => {
			const sourceSupported = isSupportedProduct(request.source.productName);
			const destinationSupported = isSupportedProduct(request.destination.productName);
			return !(sourceSupported && destinationSupported);
		}).length,
	};
}
